/**
 * WhatsApp CTA utility.
 * Builds a wa.me link with a contextual pre-filled message per page/language.
 *
 * Phone: +351 931 997 415 (Your Broker Portugal — Alex Kühne)
 */
export const WHATSAPP_NUMBER = '351931997415';

const MESSAGES = {
  pt: {
    default: 'Olá, vim do site da Your Broker Portugal. Gostaria de iniciar uma conversa privada sobre uma aquisição em Portugal.',
    home: 'Olá, vim do site da Your Broker Portugal. Gostaria de iniciar uma conversa privada.',
    advisory: 'Olá, vim da página Consultoria. Gostaria de saber mais sobre o vosso modelo de representação.',
    services: 'Olá, vim da página Serviços. Gostaria de discutir um mandato de aquisição.',
    regions: 'Olá, vim da página Regiões. Tenho interesse em conhecer melhor uma região específica.',
    international: 'Olá, vim da página International. Gostaria de iniciar uma conversa privada sobre uma aquisição em Portugal.',
    journal: 'Olá, vim do Journal. Gostaria de conversar privadamente.',
  },
  en: {
    default: 'Hello, I came from the Your Broker Portugal website. I would like to begin a private conversation about acquiring property in Portugal.',
    home: 'Hello, I came from the Your Broker Portugal website. I would like to begin a private conversation.',
    advisory: 'Hello, I came from the Advisory page. I would like to learn more about your representation model.',
    services: 'Hello, I came from the Services page. I would like to discuss an acquisition mandate.',
    regions: 'Hello, I came from the Regions page. I would like to learn more about a specific region.',
    international: 'Hello, I came from the International page. I would like to begin a private conversation about acquiring property in Portugal.',
    journal: 'Hello, I came from the Journal. I would like to have a private conversation.',
  },
};

export const buildWhatsAppUrl = (page = 'default', language = 'pt') => {
  const lang = MESSAGES[language] ? language : 'pt';
  const text = MESSAGES[lang][page] || MESSAGES[lang].default;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
};
